<template>
  <b-button variant="outline-info" v-on:click="pressed">{{$t('EDIT')}}</b-button>
</template>
<script>
export default {
  props: ["UserID", "token"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      this.$emit("edit", this.UserID);
    }
  }
};
</script>